import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useHeaderFilters } from '@/features/header-filters';

import { useReceiveHistoryFilters } from '../model';
import { ReceiveHistoryFilters } from './receive-history-filters';
import { ReceiveHistoryPage } from './receive-history-page';

export function ReceiveHistoryWithFilters() {
  const { t } = useTranslation();
  const { setFilterConfig, setSearchConfig } = useHeaderFilters();

  const {
    urlState,
    searchQuery,
    activeFiltersCount,
    activeFilters,
    isFiltersDirty,
    hasDefaultFilters,
    handleFilterChange,
    handleDateRangeChange,
    handleSearchChange,
    handleReset,
    handleApplyFilters
  } = useReceiveHistoryFilters();

  useEffect(() => {
    setSearchConfig({
      defaultValue: searchQuery,
      placeholder: t('gen.search.desc', 'Search among relevant properties'),
      onChange: handleSearchChange,
      enabled: true
    });
  }, [handleSearchChange, searchQuery, setSearchConfig, t]);

  useEffect(() => {
    const filterContent = (
      <ReceiveHistoryFilters
        filters={urlState}
        onFilterChange={handleFilterChange}
        onDateRangeChange={handleDateRangeChange}
      />
    );

    setFilterConfig({
      id: 'receive-history-filters',
      title: t('receive.history.filters.title', 'Filter Receive History'),
      content: filterContent,
      activeCount: activeFiltersCount,
      activeFilters,
      onReset: handleReset,
      onApply: handleApplyFilters,
      onClearAll: handleReset,
      isApplyDisabled: !isFiltersDirty,
      isResetDisabled: hasDefaultFilters
    });
  }, [
    activeFiltersCount,
    activeFilters,
    handleApplyFilters,
    handleDateRangeChange,
    handleFilterChange,
    handleReset,
    hasDefaultFilters,
    isFiltersDirty,
    setFilterConfig,
    t,
    urlState
  ]);

  return <ReceiveHistoryPage />;
}
